import React from "react";
import { useEffect } from "react";
import { useDrop } from "react-dnd";
import { TraningExercisesWrapper } from "../style";

export const DraggableExerciseDropZone: React.FC<any> = ({
  children,
  partKey,
  onDrop,
  moveItem,
}: any) => {
  const dropZoneRef = React.useRef<HTMLDivElement>(null);

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "exercise",
      drop: (item: any, monitor) => {
        const dropZone = dropZoneRef.current;
        if (!dropZone) {
          console.error("Drop zone ref not found");
          return;
        }

        const rect = dropZone.getBoundingClientRect(); // Get drop zone dimensions
        const pointerY = monitor.getClientOffset()?.y || 0; // Pointer Y position
        const relativeY = pointerY - rect.top; // Position relative to drop zone top
        const itemHeight = 150;
        const targetIndex = Math.floor(relativeY / itemHeight); // Calculate index
        onDrop(partKey, item.exercise, targetIndex);
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [partKey]
  );

  useEffect(() => {
    if (dropZoneRef.current) {
      drop(dropZoneRef);
    }
  }, [drop]);

  return (
    <TraningExercisesWrapper ref={dropZoneRef}>
      {children}
    </TraningExercisesWrapper>
  );
};
